import React from 'react';

const SvgCaf = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CAF_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CAF_svg__b" fill="#fff">
        <use xlinkHref="#CAF_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CAF_svg__a" />
      <path fill="#19BFBF" mask="url(#CAF_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M8.055 5.66a.715.715 0 0 1 .182-.563l2.193-2.194a.944.944 0 0 1 .567-.236h1.34c.182 0 .396.132.478.296l.37.741A.578.578 0 0 0 13.66 4h2.013c.18 0 .394.133.477.3l1.7 3.4c.083.165.307.3.48.3h1.34c.182 0 .244.115.13.265l-1.6 2.136c-.11.147-.266.398-.348.562l-.37.741a1.642 1.642 0 0 0-.149.632v.66c0 .187-.066.47-.148.633l-.37.742-.296.592-.371.741-.296.592-.37.741a.58.58 0 0 1-.485.296h-.66a.591.591 0 0 1-.485-.296l-.37-.741a1.685 1.685 0 0 1-.149-.637v-3.318a.932.932 0 0 0-.24-.582l-.186-.185a1.702 1.702 0 0 1-.345-.553l-.458-1.375a.483.483 0 0 0-.436-.313h-2.67a.41.41 0 0 1-.386-.327l-.557-3.345zM18.667 13.66c0-.18.142-.327.336-.327h.66c.186 0 .337.143.337.337v.66c0 .186-.066.47-.148.633l-.37.741A.596.596 0 0 1 19 16a.328.328 0 0 1-.333-.327V13.66z"
        fill="#FFF"
        mask="url(#CAF_svg__b)"
      />
    </g>
  </svg>
);

export default SvgCaf;
